import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-checklist",
  "use": "icon-checklist-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol viewBox=\"0 0 48 48\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-checklist\"><path d=\"M11.3885 36.3961L5 30.0077L6.58075 28.427L11.3692 33.1847L20.2038 24.35L21.7845 25.9808L11.3885 36.3961ZM11.3885 21.1654L5 14.777L6.58075 13.1963L11.3692 17.9539L20.2038 9.11932L21.7845 10.7501L11.3885 21.1654ZM26.0192 32.75V30.4808H43.0191V32.75H26.0192ZM26.0192 17.5193V15.2501H43.0191V17.5193H26.0192Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol